/** Numbers as a reader reads them, and text as HTML cannot misread it. */

export function escapeHtml(text: string): string {
  return text.replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!);
}

export function count(value: number): string {
  return value.toLocaleString("en-GB");
}

/** "1.2k" past a thousand, which is what fits inside a bubble. */
export function compact(value: number): string {
  if (value < 1000) return String(Math.round(value));
  const thousands = value / 1000;
  return `${thousands < 10 ? thousands.toFixed(1) : Math.round(thousands)}k`;
}

export function money(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return "—";
  if (value >= 1e6) return `£${(value / 1e6).toFixed(2)}m`;
  if (value >= 1000) return `£${Math.round(value / 1000)}k`;
  return `£${Math.round(value)}`;
}

export function metres(value: number): string {
  return value < 950 ? `${Math.round(value / 10) * 10} m` : `${(value / 1000).toFixed(1)} km`;
}

/** Walking minutes at 80 m a minute, which is the usual planning pace. */
export function walkMinutes(metresAway: number): number {
  return Math.max(1, Math.round(metresAway / 80));
}

/** A percentile on 0..1 as the 0-100 the interface shows; null for no answer. */
export function asHundred(value: number): number | null {
  return Number.isFinite(value) ? Math.round(value * 100) : null;
}

export function percent(value: number | null): string {
  return value === null ? "—" : String(value);
}
